module.exports = __webpack_public_path__ + "static/media/iguazu-falls-13.079a73e3.jpg";